import React from "react";
import { injectIntl } from "react-intl";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Radio from "@material-ui/core/Radio";
import { compose } from "recompose";
import { Field } from "redux-form";
import Lock from "@material-ui/icons/Lock";
import LockOpen from "@material-ui/icons/LockOpen";
import useTheme from "@material-ui/core/styles/useTheme";

const phi = ({ theme, input, meta, intl, value, ...rest }) => {
  return (
    <Grid container direction="column" justify="flex-start">
      <Grid item>
        <FormControl style={{ width: "100%", minHeight: "47px" }}>
          <RadioGroup {...input} {...rest}>
            <Grid
              container
              direction="row"
              alignItems="baseline"
              justify="flex-start"
              spacing={2}
            >
              <Grid
                item
                style={{ color: "white", flex: 0.5, justifySelf: "flex-start" }}
              >
                <Paper
                  elevation={0}
                  style={{
                    borderRadius: 0,
                    padding: 0,
                    margin: 0,
                    height: "67px",
                    backgroundColor: "rgb(24, 35, 48)",
                  }}
                >
                  <Grid
                    container
                    alignItems="center"
                    style={{ height: "100%" }}
                    spacing={1}
                  >
                    <Grid item>
                      <Radio
                        color="secondary"
                        style={{ color: "white", width: "100%" }}
                        value="1"
                      />
                    </Grid>
                    <Grid item>
                      <LockOpen
                        style={{
                          fontSize: "28px",
                          color: "#86ceb4",
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography style={{ color: "white" }}>
                        {intl.formatMessage({ id: "app.circles.phiFree" })}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>

              <Grid
                item
                style={{
                  color: "white",
                  flex: 0.5,
                  justifySelf: "flex-start",
                }}
              >
                <Paper
                  elevation={0}
                  style={{
                    borderRadius: 0,
                    padding: 0,
                    margin: 0,
                    height: "67px",
                    backgroundColor: "rgb(24, 35, 48)",
                  }}
                >
                  <Grid
                    container
                    alignItems="center"
                    style={{ height: "100%" }}
                    spacing={1}
                  >
                    <Grid item>
                      <Radio
                        color="secondary"
                        style={{ color: "white", width: "100%" }}
                        value="2"
                      />
                    </Grid>
                    <Grid item>
                      <Lock
                        style={{
                          fontSize: "28px",
                          color: "#86ceb4",
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <Typography style={{ color: "white" }}>
                        {intl.formatMessage({ id: "app.circles.phi" })}
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </RadioGroup>
        </FormControl>
      </Grid>
      <Grid
        item
        style={{
          alignSelf: "flex-start",
          marginTop: "10px",
          minHeight: "90px",
        }}
      >
        {input.value === "1" ? (
          <Typography
            variant="body2"
            style={{ color: "white", paddingTop: "4px", textAlign: "left" }}
          >
            {intl.formatMessage({ id: "app.circles.phiFreeMessage" })}
            <Link
              to="terms"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
            >
              {intl.formatMessage({ id: "app.terms.title" })}.
            </Link>
          </Typography>
        ) : (
          <Typography
            variant="body2"
            style={{ color: "white", paddingTop: "4px", textAlign: "left" }}
          >
            {intl.formatMessage({ id: "app.circles.phiMessage" })}
            <Link
              to="terms"
              target="_blank"
              style={{ textDecoration: "none", color: "white" }}
            >
              {intl.formatMessage({ id: "app.terms.title" })}.
            </Link>
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

const PhiSelection = ({ intl }) => {
  var theme = useTheme();
  return (
    <div style={{ color: "white" }}>
      <Field name="phi" component={phi} intl={intl} theme={theme} />
    </div>
  );
};

const enhance = compose(injectIntl);

export default enhance(PhiSelection);
